import { API_ROOT } from ".";
import { setImages, setRangeSettings, setRangeValues } from "../../actions/webcamAction";
import format from "date-fns/format";

const getCamArchive = async (postData) => {

    const form_api_url = API_ROOT + 'getcamarchive.php';

    var myHeaders = new Headers();
    //myHeaders.append("Authorization", "Bearer " + bearerToken);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(postData)
    };

    try {
        const response = await fetch(form_api_url, requestOptions);
        if (response.ok) {
            const json = await response.json();
            return json;
        }
        else {
            return { resource_id: postData.resource_id, error: 'Not Found' }
        }


    } catch (error) {
        console.log(error);
    }
};

export const getCameraImages = async (dispatch, camera, type='daily', date=new Date())=>{
    var camid = camera.id;
    var request = {
        id: camid,
        type: type,
        date: format(date, "yyyy-MM-dd")
    }
    var image_size = camera.image_size ? camera.image_size : '1210';

    if(image_size === 'full'){
        //full image size only available from 13th May 2023.
        var targetDate = new Date(2023, 4, 13);    
        if (date.getTime() < targetDate.getTime()) {
            //console.log('full size image not available on selected date');
            image_size = '1210';
        }
    }
    await getCamArchive(request).then((data) => {
        if (typeof data.archive !== 'undefined') {
            var imagesArr = [];
            if(data.archive !== null) {
                Object.values(data.archive).map((image, innerkey) => {
                    var imgpath = image.imgpath;
                    var parts = imgpath.split(".");
                    imagesArr.push({
                        original: 'https://webcamwidget.fullmarketing.at/camsimg/' + camid + '/' + parts.join('-'+image_size+'.'),
                        thumbnail: 'https://webcamwidget.fullmarketing.at/camsimg/' + camid + '/' + parts.join('-310.'),
                        timestamp: image.timestamp,
                        originalTitle: image.timeInner,
                    });
                })
            } else {
                imagesArr.push({
                    original: 'https://dummyimage.com/1200x800/b5b5b5/ffffff.jpg&text=No+image+found,+please+select+different+date',
                    thumbnail: 'https://dummyimage.com/1200x800/b5b5b5/ffffff.jpg&text=No+image+found,+please+select+different+date',
                    timestamp: new Date().getTime(),
                    originalTitle: 'No Image',
                });
            }                        
            
            //setCamImages(imagesArr, camid);
            dispatch(setImages(imagesArr, camid));
            var setting = {'max':imagesArr.length-1, 'step':1}
            //setCamRangeSettings(setting, camid);
            dispatch(setRangeSettings(setting, camid));
            //setCamRangeValues(imagesArr.length-1, camid);
            dispatch(setRangeValues(imagesArr.length-1, camid));
        } 
    });
}

export default getCamArchive;